<template>
  <!-- 进度 -->
  <div class="MyComment">
    <div class="MyComment_box">
      <div class="MyComment_header">心愿完成评价</div>
      <dl>
        <dt>我的心愿</dt>
        <dd>
          {{ data.content | ellipsis }}
        </dd>
      </dl>
      <dl>
        <dt>心愿评价</dt>
        <dd>
          <div class="textarea_box">
            <van-field
              v-model="comment"
              row="5"
              type="textarea"
              maxlength="200"
              placeholder="请输入内容"
              show-word-limit
            />
          </div>
        </dd>
      </dl>
      <dl>
        <dt>满意度</dt>
        <dd>
          <van-radio-group
            v-model="radio"
            direction="horizontal"
            @click="hanldeClick"
          >
            <van-radio name="4" shape="square" checked-color="#ee0a24"
              >非常满意<template #icon="props">
                <img
                  class="img-icon"
                  :src="props.checked ? activeIcon : inactiveIcon"
                /> </template
            ></van-radio>
            <van-radio name="3" shape="square" checked-color="#ee0a24"
              >满意<template #icon="props">
                <img
                  class="img-icon"
                  :src="props.checked ? activeIcon : inactiveIcon"
                /> </template
            ></van-radio>
            <van-radio name="2" shape="square" checked-color="#ee0a24"
              >基本满意<template #icon="props">
                <img
                  class="img-icon"
                  :src="props.checked ? activeIcon : inactiveIcon"
                /> </template
            ></van-radio>
            <van-radio name="1" shape="square" checked-color="#ee0a24"
              >不满意<template #icon="props">
                <img
                  class="img-icon"
                  :src="props.checked ? activeIcon : inactiveIcon"
                /> </template
            ></van-radio>
          </van-radio-group>
        </dd>
      </dl>
      <Button :button="sureBtn" @click.native="publishComment" />
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
export default {
  props: ["isShow", "data"],
  data() {
    return {
      comment: "", //用户的评价
      sureBtn: "确定",
      radio: "4",
      activeIcon: "http://img.wish.hebyun.com.cn/images/user-active.png",
      inactiveIcon: "http://img.wish.hebyun.com.cn/images/user-inactive.png",
    };
  },
  components: {
    Button,
  },
  filters: {
    ellipsis(_val) {
      if (!_val) return "";
      if (_val.length > 50) {
        return _val.slice(0, 50) + "...";
      }
      return _val;
    },
  },
  methods: {
    async publishComment() {
      let data = {
        wishid: this.data.id,
        comment: this.comment,
        satisfaction: this.radio, //1不满意2基本满意3满意4非常满意
      };
      await this.$api.publishWishComment(data);
      this.$toast("评价成功");
      this.$emit("handleIsShow", false);
    },
    hanldeClick() {
      console.log("点击了");
    },
  },
};
</script>
<style lang="scss">
.img-icon {
  height: 12.5px;
}
.MyComment {
  .btn {
    width: 130px;
    height: 30px;
    span {
      font-size: 15px;
    }
  }
}
</style>
<style lang="scss" scoped>
.MyComment {
  .MyComment_box {
    width: 334px;
    height: 486.5px;
    overflow-y: scroll;
    background-color: #fff8d6;
    border-radius: 10px;
    padding: 0 20px 20px;
    box-sizing: border-box;
    .MyComment_header {
      font-size: 15px;
      color: #e50012;
      font-weight: bold;
      width: 100%;
      text-align: center;
      padding: 15px 0 0;
    }
    .textarea_box {
      flex: 1;
      position: relative;
      width: 295px;
      height: 160px;
      background-color: #ffffff;
      border-radius: 10px;
      font-size: 13px;
      line-height: 1;
      color: #999999;
      overflow: hidden;
      margin-bottom: 5px;
      /deep/.van-cell {
        height: 160px;
        padding: 9px;
        box-sizing: border-box;
      }
      /deep/.van-field__body {
        height: 130px;
      }
      /deep/.van-field__control {
        height: 130px;
        font-size: 14px;
        color: #666666;
      }
    }
  }
  dl {
    width: 100%;
    font-size: 14px;
    text-align: left;
    dt {
      color: #e50012;
      font-weight: bold;
      margin-bottom: 12px;
    }
    dd {
      text-align: left;
      margin: 0;
      .van-radio {
        align-items: center;
        margin-right: 5px;
        /deep/ .van-radio__icon {
          height: 12.5px;
          width: 12.5px;
          font-size: inherit;
          .van-icon {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
        /deep/ .van-radio__label {
          line-height: normal;
        }
      }
    }
  }
}
</style>
